<template>
  <div>
    <nav-breadcrumb :menu="[{label: '授信记录'}, {label: '授信详情'}]"/>
    <el-steps :active="6" class="step-shenpi">
      <el-step :title="'提交授信  '"  :description="$moment(creditData.ac__createdDate).format('YYYY-MM-DD HH:mm:ss')">
        <i class="step-start" slot="icon"></i>
      </el-step>
      <el-step v-if="approvalListcount>0" :title="Status2CN(approvalList[0].a__approvalType)+approvalList[0].a__approverName" :description="$moment(approvalList[0].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[0].a__approvingStatus)" >
        <i class="step-mid" slot="icon"></i>
      </el-step>
      <el-step v-if="approvalListcount>1" class="step-spec" :title="Status2CN(approvalList[1].a__approvalType)+approvalList[1].a__approverName"  :description="$moment(approvalList[0].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[1].a__approvingStatus)" >
        <i class="step-mid" slot="icon"></i>
      </el-step>
      <el-step v-if="approvalListcount>2" class="step-spec" :title="Status2CN(approvalList[2].a__approvalType)+approvalList[2].a__approverName"  :description="$moment(approvalList[1].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[2].a__approvingStatus)" >
        <i class="step-mid" slot="icon"></i>
      </el-step>
      <el-step v-if="approvalListcount>3" class="step-spec" :title="Status2CN(approvalList[3].a__approvalType)+approvalList[3].a__approverName"  :description="$moment(approvalList[2].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[3].a__approvingStatus)" >
        <i class="step-mid" slot="icon"></i>
      </el-step>
      <el-step v-if="approvalListcount>4" class="step-spec" :title="Status2CN(approvalList[4].a__approvalType)+approvalList[4].a__approverName"  :description="$moment(approvalList[3].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[4].a__approvingStatus)" >
        <i class="step-mid" slot="icon"></i>
      </el-step>
      <el-step :title="'完成'" v-if="creditData.ac__applicationStatus == 'Approved'" >
        <i class="step-over" slot="icon"></i>
      </el-step>
    </el-steps>
    <credit-detail-component :creditData="creditData" />
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import CreditDetailComponent from '../../components/CreditDetailComponent'
  import Status2CN from "../../../filters/Status2CN";

  export default {
    name: "ServerAdminCreditDetail",
    data() {
      return {
        approvalListcount:0,
        approvalList: [],
        applicationId:'',
        filterOption: {
          'cr.creditId' : this.$route.query['cr.creditId']
        },
        creditData: {
          files: []
        }
      }
    },
    components: {
      CreditDetailComponent
    },
    mounted() {
      this.getCustomerCreditDetail()
    },
    methods: {
      Status2CN,
      getCustomerCreditDetail: function () {
        xhr.getCustomerCreditDetail(Object.assign(this.filterOption,{}), res=>{
          try{
            if(res.data.status == 'success') {
              this.creditData = res.data.data
              this.applicationId = res.data.data.ac__applicationId
              this.getCustomerApprovalList()
             /* this.getCustomerDetail(this.creditData.)*/
            }
          }catch(e){}
        })
      },
      getCustomerApprovalList: function() {
        xhr.getCustomerApprovalList(
          {
            'a.applicationId':this.applicationId,
            pageSize: 100
          },
          res=>{
            try {
              if(res.data.status == 'success') {
                this.approvalList = res.data.data
                this.approvalListcount = res.data.count
              }
            }catch (e) {

            }
          }
        )
      }
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/CreditDetail.vue